// extracted by mini-css-extract-plugin
export default {"servicesBlock":"PaidServices_servicesBlock__K1FyT","imgBlock_left":"PaidServices_imgBlock_left__P2FyP"};